<template>
  <div class="GradeLearning edit-style">
    <!-- {{ isAndroid }} -->
    <!-- {{ subjectlistbygradeList }} -->
    <!-- {{ getGradelistData }}
    {{ searchData }} -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="downView" />
      <p class="title">年级考点</p>
      <img src="@/assets/learning/setting.png" alt="" @click="toSetting" />
    </div>
    <div class="header-box">
      <div class="sort-box">
        <div
          v-for="v in sortList"
          :key="v.val"
          class="sort-list"
          :class="{ on: v.click }"
          @click="sortClick(v)"
        >
          {{ v.name }}
        </div>
      </div>
    </div>
    <knowledge
      v-if="keyType && sortList.filter((item) => item.click)[0].val == 1"
      :search-data="searchData"
    ></knowledge>
    <overview
      v-if="keyType && sortList.filter((item) => item.click)[0].val == 2"
      :search-data="searchData"
    ></overview>
    <wrongQuestion
      v-if="keyType && sortList.filter((item) => item.click)[0].val == 3"
      :search-data="searchData"
    ></wrongQuestion>
  </div>
</template>

<script>
import { Toast } from "vant";
import knowledge from "@/components/learning/knowledge";
import overview from "@/components/learning/overview";
import wrongQuestion from "@/components/learning/wrongQuestion";
// import { subjectOptions } from "@/util/constdata";
import { getGradelist, subjectlistbygrade } from "@/api/interface";
export default {
  name: "GradeLearning",
  components: {
    knowledge,
    overview,
    wrongQuestion,
  },
  data() {
    return {
      subjectOptions: [],
      sortList: [
        { name: "知识点", val: 1, click: false },
        { name: "概况", val: 2, click: false },
        { name: "错题", val: 3, click: false },
      ],

      searchData: {
        subjectId: "",
        timeRange: 0,
        gradeId: 0,
      },
      keyType: false,
      knowledList: [],
      // subjectlistbygradeList: [],
      current: 0,
      apiData: {},
      getGradelistData: [],
    };
  },
  created() {
    this.getPhoneType();
  },
  mounted() {
    let type = this.$route.query.isWeb;
    // console.log("11111111111");
    if (type) {
      if (this.$route.query.token) {
        this.$store.commit("setToken", this.$route.query.token);
        this.$store.commit("setSchoolId", this.$route.query.schoolID);
      }
      // this.apiData.gradeId = this.$route.query.gradeId;
      // this.apiData.classNum = this.$route.query.classNum;
      this.init();
    } else {
      window.initView = this.initView;
      window.goBackView = this.goBackView;
      this.initMobile();
    }
  },
  methods: {
    getPhoneType() {
      let u = navigator.userAgent;
      this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    downWindow() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 3,
        });
      } else {
        // return;
        window.mobile.hideTitleBar();
      }
    },
    goBackView() {
      this.downView();
    },
    initMobile() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", data.token);
      this.$store.commit("setSchoolId", data.schoolID);
      this.init();
      this.downWindow();
    },
    downView() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 1,
        });
      } else {
        window.mobile.closeMobileUI();
      }
    },
    // 有科目id就展示页面没有就获取科目
    subjectlistbygrade() {
      if (this.searchData.subjectId) {
        this.getKnowList();
        return;
      }
      let data = {
        // token: this.apiData.token,
        gradeId: this.searchData.gradeId,
      };
      subjectlistbygrade(data).then((res) => {
        this.subjectOptions = res.data;
        if (this.subjectOptions && this.subjectOptions.length == 0) {
          Toast("该账号没有科目");
          return;
        }
        this.searchData.subjectId = this.subjectOptions[0].id;
        this.getKnowList();
      });
    },
    init() {
      this.sortList[0].click = true;
      Object.assign(this.searchData, this.apiData);
      if (this.$route.query.gradeId) {
        Object.assign(this.searchData, this.$route.query);
      }

      delete this.searchData.schoolID;
      delete this.searchData.classNum;
      //有年级id就获取科目，没有年级id就获取年级
      if (this.searchData.gradeId) {
        this.subjectlistbygrade();
      } else {
        this.getOption();
      }
    },
    toSetting() {
      let data = JSON.parse(JSON.stringify(this.searchData));
      data.path = this.$route.name;
      if (this.$route.query.isWeb) {
        data.isWeb = true;
      }
      data.urlType = "grade";
      delete data.current;
      delete data.size;
      delete data.token;
      delete data.schoolID;
      this.$store.commit("delKeepArr");
      this.$router.push({
        name: "SettingLearning",
        query: data,
      });
    },
    getKnowList() {
      this.keyType = true;
    },
    getOption() {
      getGradelist().then((res) => {
        this.getGradelistData = res.data;
        this.searchData.gradeId = res.data[0].id;
        this.subjectlistbygrade();
        // this.getKnowList();
      });
    },
    sortClick(v) {
      this.sortList.forEach((i) => {
        i.click = false;
      });
      v.click = true;
    },
  },
};
</script>

<style scoped lang="scss">
.GradeLearning {
}
</style>
